import { Dimensions, Platform, PixelRatio } from "react-native";
const { width, height } = Dimensions.get("window");

function normalize(size) {
  const newSize = size * scale;
  if (Platform.OS === "ios") {
    return Math.round(PixelRatio.roundToNearestPixel(newSize));
  } else {
    return Math.round(PixelRatio.roundToNearestPixel(newSize)) - 2;
  }
}
const maxScreenHeight = 930;
const maxScreenWidth = 450;
const SCREEN_HEIGHT = height > maxScreenHeight ? maxScreenHeight : height;
const SCREEN_WIDTH = width > maxScreenWidth ? maxScreenWidth : width;

// based on iphone 5s's scale
const scale = SCREEN_WIDTH / 350;

export { normalize, SCREEN_HEIGHT, SCREEN_WIDTH };

export function lightenColor(color, opacity) {
  return color + opacity;
}
